/* Cat'N Shop Theme — theme.js */

document.addEventListener('DOMContentLoaded', () => {
  initLangSwitcher();
  initAnnouncementBar();
  initSearch();
  initMobileNav();
  initCartDrawer();
  initGallery();
  initQty();
  initProductOptions();
  initScrollTop();
  initSliders();
  initFooterAccordion();
});

/* ---- Announcement Bar ---- */
function initAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  const close = bar?.querySelector('.announcement-bar__close');
  if (!close) return;
  close.addEventListener('click', () => {
    bar.style.maxHeight = bar.offsetHeight + 'px';
    requestAnimationFrame(() => {
      bar.style.transition = 'max-height .3s, opacity .3s';
      bar.style.maxHeight = '0';
      bar.style.opacity = '0';
      bar.style.overflow = 'hidden';
    });
    setTimeout(() => bar.remove(), 350);
  });
}

/* ---- Language Switcher ---- */
function initLangSwitcher() {
  const toggle = document.querySelector('.lang-toggle');
  const dropdown = document.querySelector('.header-top__right .lang-dropdown');
  if (!toggle || !dropdown) return;

  toggle.addEventListener('click', e => {
    e.stopPropagation();
    const open = dropdown.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open);
  });

  document.addEventListener('click', () => {
    dropdown.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
  });

  dropdown.addEventListener('click', e => e.stopPropagation());
}

/* ---- Search ---- */
function initSearch() {
  const searchBar = document.getElementById('search-bar');
  const searchBtn = document.querySelector('.header-search-btn');
  const closeBtn = searchBar?.querySelector('.search-close');
  if (!searchBtn || !searchBar) return;
  searchBtn.addEventListener('click', () => {
    searchBar.hidden = false;
    searchBar.querySelector('.search-input')?.focus();
  });
  closeBtn?.addEventListener('click', () => { searchBar.hidden = true; });
}

/* ---- Mobile Nav Drawer ---- */
function initMobileNav() {
  const toggle = document.querySelector('.nav-toggle');
  const drawer = document.getElementById('nav-drawer');
  const overlay = document.getElementById('nav-drawer-overlay');
  const closeBtn = document.getElementById('nav-drawer-close');
  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openDrawer);
  overlay?.addEventListener('click', closeDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Fermer le drawer quand on clique sur un lien
  drawer.querySelectorAll('.nav-drawer__link').forEach(link => {
    link.addEventListener('click', closeDrawer);
  });
}

/* ---- Footer accordéon mobile ---- */
function initFooterAccordion() {
  document.querySelectorAll('.footer__col-title').forEach(title => {
    const col = title.closest('.footer__col');
    if (!col || col.classList.contains('footer__col--newsletter')) return;
    title.addEventListener('click', () => {
      col.classList.toggle('open');
    });
  });
}

/* ---- Cart Drawer ---- */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const overlay = drawer.querySelector('.cart-drawer__overlay');
  const closeBtn = drawer.querySelector('.cart-drawer__close');
  const body = document.getElementById('cart-drawer-body');

  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCartHTML();
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.cart-toggle').forEach(el => el.addEventListener('click', open));
  overlay?.addEventListener('click', close);
  closeBtn?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  // AJAX add-to-cart
  document.querySelectorAll('.product-card__atc-form, .product-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[name="add"]');
      if (!btn || btn.disabled) return;
      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (res.ok) {
          await updateCartBadge();
          open();
        }
      } finally {
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
      }
    });
  });

  async function fetchCartHTML() {
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.item_count === 0) {
        body.innerHTML = emptyCartHTML();
        return;
      }
      const items = cart.items.map(item => `
        <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #eee;align-items:flex-start;">
          <img src="${item.image}" alt="${item.title}" style="width:64px;height:64px;object-fit:contain;border:1px solid #eee;border-radius:3px;padding:4px;flex-shrink:0;">
          <div style="flex:1;min-width:0;">
            <p style="font-weight:700;font-size:.82rem;margin-bottom:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${item.product_title}</p>
            ${item.variant_title !== 'Default Title' ? `<p style="font-size:.75rem;color:#999;margin-bottom:4px;">${item.variant_title}</p>` : ''}
            <p style="font-weight:800;font-size:.85rem;color:#e53935;">${fmt(item.final_price)}</p>
            <p style="font-size:.75rem;color:#999;margin-top:2px;">Qté : ${item.quantity}</p>
          </div>
        </div>`).join('');
      // Barre de progression livraison gratuite
      const cfg = window.CATNSHOP?.freeShipping || {};
      if (cfg.enabled === false) { cfg._skip = true; }
      const FREE_SHIPPING_THRESHOLD = cfg.threshold || 5000;
      const gap = FREE_SHIPPING_THRESHOLD - cart.total_price;
      const pct = Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
      const shippingBar = cfg._skip ? '' : gap > 0
        ? `<div style="background:#f0fafc;border-radius:8px;padding:12px 14px;margin-bottom:14px;">
            <p style="font-size:.78rem;color:#005f6b;margin-bottom:8px;">🚚 ${(cfg.messageTemplate||'Plus que {amount} pour la livraison gratuite !').replace('{amount}', fmt(gap))}</p>
            <div style="background:#d0eff4;border-radius:99px;height:6px;overflow:hidden;">
              <div style="background:#00BCD4;height:100%;width:${pct}%;border-radius:99px;transition:width .4s;"></div>
            </div>
          </div>`
        : `<div style="background:#e8f5e9;border-radius:8px;padding:10px 14px;margin-bottom:14px;text-align:center;">
            <p style="font-size:.78rem;color:#2e7d32;font-weight:700;">🎉 ${cfg.messageUnlocked||'Livraison gratuite débloquée !'}</p>
          </div>`;
      body.innerHTML = `
        <div>${items}</div>
        <div style="padding-top:16px;border-top:2px solid #eee;margin-top:4px;">
          ${shippingBar}
          <div style="display:flex;justify-content:space-between;font-weight:800;margin-bottom:16px;">
            <span>Sous-total</span><span>${fmt(cart.total_price)}</span>
          </div>
          <a href="/checkout" style="display:flex;align-items:center;justify-content:center;padding:14px;background:#00BCD4;color:#fff;font-family:Montserrat,sans-serif;font-weight:800;font-size:.82rem;letter-spacing:.8px;text-transform:uppercase;border-radius:3px;text-decoration:none;transition:background .2s;" onmouseover="this.style.background='#0097A7'" onmouseout="this.style.background='#00BCD4'">Passer la commande</a>
          <a href="/cart" style="display:flex;align-items:center;justify-content:center;padding:10px;margin-top:8px;border:1px solid #ddd;border-radius:3px;font-size:.78rem;font-weight:700;color:#666;text-decoration:none;font-family:Montserrat,sans-serif;letter-spacing:.5px;text-transform:uppercase;">Voir le panier</a>
        </div>`;
    } catch {
      body.innerHTML = '<p style="text-align:center;color:#999;font-size:.85rem;padding:20px 0;">Erreur de chargement du panier.</p>';
    }
  }

  function emptyCartHTML() {
    return `<div style="text-align:center;padding:48px 20px;">
      <div style="font-size:2.5rem;margin-bottom:12px;">🛒</div>
      <p style="font-weight:700;margin-bottom:6px;">Votre panier est vide</p>
      <p style="font-size:.82rem;color:#999;margin-bottom:20px;">Ajoutez des produits pour nos amis les chats !</p>
      <a href="/collections/all" style="padding:12px 24px;background:#00BCD4;color:#fff;font-family:Montserrat,sans-serif;font-weight:700;font-size:.8rem;border-radius:3px;text-decoration:none;text-transform:uppercase;letter-spacing:.5px;">Voir nos produits</a>
    </div>`;
  }
}

async function updateCartBadge() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cart-count');
    if (badge) badge.textContent = cart.item_count;
  } catch {}
}

function fmt(cents) {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

/* ---- Product Gallery ---- */
function initGallery() {
  const mainImg = document.getElementById('main-product-img');
  if (!mainImg) return;
  document.querySelectorAll('.product-gallery__thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      mainImg.src = btn.dataset.src;
      document.querySelectorAll('.product-gallery__thumb').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

/* ---- Qty Controls ---- */
function initQty() {
  document.querySelectorAll('.qty-minus, .qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-wrap')?.querySelector('.qty-input');
      if (!input) return;
      let v = parseInt(input.value) || 1;
      input.value = btn.classList.contains('qty-minus') ? Math.max(1, v - 1) : v + 1;
    });
  });
}

/* ---- Product Options ---- */
function initProductOptions() {
  const select = document.querySelector('.variant-hidden-select');
  if (!select) return;
  document.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.product-option__btns')?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      // Simple variant matching
      const values = Array.from(document.querySelectorAll('.option-btn.selected')).map(b => b.dataset.val);
      for (const opt of select.options) {
        const parts = opt.textContent.split(' — ')[0].trim();
        if (values.every(v => parts.includes(v))) { opt.selected = true; break; }
      }
    });
  });
}

/* ---- Scroll to Top ---- */
function initScrollTop() {
  const btn = document.getElementById('scroll-top-btn');
  btn?.addEventListener('click', e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
}

/* ---- FAQ Accordion + Search + Categories ---- */
function initFAQ() {
  // Accordéon
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Fermer tous
      document.querySelectorAll('.faq-q').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling?.classList.remove('open');
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer?.classList.add('open');
      }
    });
  });

  // Filtres catégories
  document.querySelectorAll('.faq-cat-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.faq-cat-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const cat = btn.dataset.cat;
      document.querySelectorAll('.faq-group').forEach(group => {
        if (cat === 'all' || group.dataset.cat === cat) {
          group.classList.remove('faq-group--hidden');
        } else {
          group.classList.add('faq-group--hidden');
          // Fermer les items du groupe caché
          group.querySelectorAll('.faq-q').forEach(b => {
            b.setAttribute('aria-expanded', 'false');
            b.nextElementSibling?.classList.remove('open');
          });
        }
      });
      // Reset search
      const searchInput = document.getElementById('faq-search');
      if (searchInput) searchInput.value = '';
    });
  });

  // Recherche live
  const searchInput = document.getElementById('faq-search');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.toLowerCase().trim();
      // Reset catégories
      document.querySelectorAll('.faq-cat-btn').forEach(b => b.classList.remove('active'));
      document.querySelector('.faq-cat-btn[data-cat="all"]')?.classList.add('active');
      document.querySelectorAll('.faq-group').forEach(g => g.classList.remove('faq-group--hidden'));

      if (!q) {
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('faq-item--hidden'));
        return;
      }
      document.querySelectorAll('.faq-item').forEach(item => {
        const text = item.textContent.toLowerCase();
        item.classList.toggle('faq-item--hidden', !text.includes(q));
        // Auto-ouvrir si match
        if (text.includes(q)) {
          const btn = item.querySelector('.faq-q');
          const ans = item.querySelector('.faq-a');
          if (btn && ans) { btn.setAttribute('aria-expanded', 'true'); ans.classList.add('open'); }
        }
      });
      // Cacher les groupes entièrement vides
      document.querySelectorAll('.faq-group').forEach(group => {
        const visible = group.querySelectorAll('.faq-item:not(.faq-item--hidden)').length;
        group.classList.toggle('faq-group--hidden', visible === 0);
      });
    });
  }
}

initFAQ();

/* ---- Product Sliders ---- */
function initSliders() {
  document.querySelectorAll('.pgs__slider').forEach(slider => {
    const id = slider.id.replace('slider-', '');
    const btnPrev = document.querySelector('.pgs__slider-btn--prev[data-target="' + id + '"]');
    const btnNext = document.querySelector('.pgs__slider-btn--next[data-target="' + id + '"]');
    // Délai entre deux défilements auto (ms)
    // Assez long pour que l'animation smooth (~400ms) se termine avant le suivant
    const DELAY = 3500;
    let timer = null;
    let isAnimating = false;

    function cardWidth() {
      const c = slider.querySelector('.product-card');
      return c ? c.offsetWidth + 16 : 226;
    }

    function updateBtns() {
      const max = slider.scrollWidth - slider.clientWidth;
      if (btnPrev) btnPrev.disabled = slider.scrollLeft <= 2;
      if (btnNext) btnNext.disabled = slider.scrollLeft >= max - 2;
    }

    function scrollSmooth(pos) {
      isAnimating = true;
      slider.scrollTo({ left: pos, behavior: 'smooth' });
      // Libère le verrou après la durée de l'animation CSS
      setTimeout(() => { isAnimating = false; }, 500);
    }

    function goNext() {
      if (isAnimating) return;
      const max = slider.scrollWidth - slider.clientWidth;
      const next = slider.scrollLeft + cardWidth();
      scrollSmooth(slider.scrollLeft >= max - 4 ? 0 : Math.min(next, max));
    }

    function goPrev() {
      if (isAnimating) return;
      scrollSmooth(Math.max(slider.scrollLeft - cardWidth(), 0));
    }

    function start() { stop(); timer = setInterval(goNext, DELAY); }
    function stop()  { clearInterval(timer); timer = null; }

    if (btnPrev) btnPrev.addEventListener('click', () => { goPrev(); stop(); setTimeout(start, 1000); });
    if (btnNext) btnNext.addEventListener('click', () => { goNext(); stop(); setTimeout(start, 1000); });

    // Pause au hover sur la section parente
    const section = slider.closest('.product-grid-section');
    if (section) {
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
    }
    slider.addEventListener('touchstart', stop, { passive: true });
    slider.addEventListener('touchend', () => setTimeout(start, 1500), { passive: true });
    slider.addEventListener('scroll', updateBtns, { passive: true });

    // Démarrage après chargement complet de la page
    function launch() { updateBtns(); setTimeout(start, 800); }
    if (document.readyState === 'complete') {
      launch();
    } else {
      window.addEventListener('load', launch);
    }
  });
}


/* ============================================================
   WISHLIST — Favoris avec localStorage
   ============================================================ */
const Wishlist = {
  KEY: 'catnshop_wishlist',

  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
    catch { return []; }
  },

  save(list) {
    localStorage.setItem(this.KEY, JSON.stringify(list));
  },

  has(id) {
    return this.get().some(p => p.id == id);
  },

  add(product) {
    const list = this.get();
    if (!this.has(product.id)) { list.push(product); this.save(list); }
  },

  remove(id) {
    this.save(this.get().filter(p => p.id != id));
  },

  toggle(product) {
    this.has(product.id) ? this.remove(product.id) : this.add(product);
  },

  count() { return this.get().length; }
};

function initWishlist() {
  // Mettre à jour tous les boutons cœur selon l'état localStorage
  function refreshButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = btn.dataset.productId;
      btn.classList.toggle('active', Wishlist.has(id));
      btn.title = Wishlist.has(id) ? (btn.dataset.removeLabel || 'Retirer des favoris') : (btn.dataset.addLabel || 'Ajouter aux favoris');
    });
  }

  // Mettre à jour le compteur header
  function refreshHeader() {
    const count = Wishlist.count();
    const headerBtn = document.getElementById('header-wishlist');
    const badge = document.getElementById('wishlist-count');
    if (headerBtn) {
      headerBtn.style.display = count > 0 ? 'flex' : 'none';
    }
    if (badge) badge.textContent = count;
  }

  function refresh() { refreshButtons(); refreshHeader(); }

  // Initialisation
  refresh();

  // Clic sur un bouton cœur
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const product = {
      id: btn.dataset.productId,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice
    };

    Wishlist.toggle(product);

    // Animation pop
    btn.classList.remove('pop');
    void btn.offsetWidth; // reflow
    btn.classList.add('pop');
    setTimeout(() => btn.classList.remove('pop'), 350);

    refresh();
  });

  // Page wishlist dédiée
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  const subtitle = document.getElementById('wishlist-subtitle');

  if (grid) {
    const items = Wishlist.get();
    if (subtitle) subtitle.textContent = items.length + ' produit' + (items.length !== 1 ? 's' : '') + ' dans vos favoris';
    if (items.length === 0) {
      grid.style.display = 'none';
      if (empty) empty.style.display = 'block';
    } else {
      grid.innerHTML = items.map(p => `
        <div class="product-card" data-product-id="${p.id}">
          <button class="product-card__wishlist active" data-wishlist-btn
            data-product-id="${p.id}" data-product-title="${p.title}"
            data-product-url="${p.url}" data-product-image="${p.image}"
            data-product-price="${p.price}" title="Retirer des favoris">
            <svg class="heart-icon heart-icon--filled" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          </button>
          <a href="${p.url}" class="product-card__image-wrap">
            <img src="${p.image}" alt="${p.title}" class="product-card__img product-card__img--main" loading="lazy">
          </a>
          <div class="product-card__info">
            <h3 class="product-card__title"><a href="${p.url}">${p.title}</a></h3>
            <div class="product-card__price-row"><span class="product-price">${p.price}</span></div>
            <a href="${p.url}" class="product-card__atc-btn" style="display:block;text-decoration:none;text-align:center;">Voir le produit</a>
          </div>
        </div>`).join('');
    }
  }
}

document.addEventListener('DOMContentLoaded', initWishlist);

/* ============================================================
   LIGHTBOX produit
   ============================================================ */
function initLightbox() {
  const lb = document.getElementById('product-lightbox');
  if (!lb) return;
  const img = document.getElementById('lightbox-img');
  const counter = document.getElementById('lightbox-counter');
  const btnPrev = document.getElementById('lightbox-prev');
  const btnNext = document.getElementById('lightbox-next');
  const images = window.__productImages || [];
  let current = 0;

  function show(idx) {
    current = (idx + images.length) % images.length;
    img.style.opacity = '0';
    setTimeout(() => {
      img.src = images[current].src;
      img.alt = images[current].alt || '';
      img.style.opacity = '1';
      img.style.transition = 'opacity .2s';
    }, 100);
    if (counter) counter.textContent = `${current + 1} / ${images.length}`;
    if (btnPrev) btnPrev.disabled = images.length <= 1;
    if (btnNext) btnNext.disabled = images.length <= 1;
  }

  function open(idx = 0) {
    if (!images.length) return;
    show(idx);
    lb.classList.add('open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    lb.classList.remove('open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Clic sur image principale
  document.getElementById('main-product-img')?.addEventListener('click', () => {
    const src = document.getElementById('main-product-img').src;
    const idx = images.findIndex(im => src.includes(im.src.split('?')[0].split('/').pop().split('.')[0]));
    open(Math.max(0, idx));
  });

  // Clic sur thumbnails
  document.querySelectorAll('.product-gallery__thumb').forEach((btn, i) => {
    btn.addEventListener('click', () => open(i));
  });

  document.getElementById('lightbox-overlay')?.addEventListener('click', close);
  document.getElementById('lightbox-close')?.addEventListener('click', close);
  btnPrev?.addEventListener('click', () => show(current - 1));
  btnNext?.addEventListener('click', () => show(current + 1));
  document.addEventListener('keydown', e => {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });
}

/* ============================================================
   ONGLETS PRODUIT
   ============================================================ */
function initProductTabs() {
  document.querySelectorAll('.product-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById('tab-' + tab)?.classList.add('active');
      // Déclencher Judge.me si l'onglet avis devient visible

    });
  });
}

/* ============================================================
   COPY LINK
   ============================================================ */
function initCopyLink() {
  const btn = document.getElementById('copy-link-btn');
  if (!btn) return;
  btn.addEventListener('click', () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      const orig = btn.innerHTML;
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
      btn.style.background = 'var(--teal)';
      btn.style.color = '#fff';
      setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; btn.style.color = ''; }, 2000);
    });
  });
}

/* ============================================================
   RECENTLY VIEWED
   ============================================================ */
function initRecentlyViewed() {
  const KEY = 'catnshop_recent';
  const MAX = 6;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  }

  // Sauvegarder le produit actuel
  if (window.__currentProduct) {
    const p = window.__currentProduct;
    const list = getRecent().filter(x => x.id !== p.id);
    list.unshift(p);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX + 1)));
  }

  // Afficher les produits récents (sauf le courant)
  const wrap = document.getElementById('recently-viewed');
  const grid = document.getElementById('recently-viewed-grid');
  if (!wrap || !grid) return;

  const currentId = window.__currentProduct?.id;
  const items = getRecent().filter(p => p.id !== currentId).slice(0, MAX);
  if (!items.length) return;

  wrap.style.display = 'block';
  grid.innerHTML = items.map(p => `
    <div class="product-card">
      <a href="${p.url}" class="product-card__image-wrap">
        <img src="${p.image}" alt="${p.title}" class="product-card__img product-card__img--main" loading="lazy">
      </a>
      <div class="product-card__info">
        <h3 class="product-card__title"><a href="${p.url}">${p.title}</a></h3>
        <div class="product-card__price-row"><span class="product-price">${p.price}</span></div>
      </div>
    </div>`).join('');
}

document.addEventListener('DOMContentLoaded', () => {
  initLightbox();
  initProductTabs();
  initCopyLink();
  initRecentlyViewed();
  initRelatedProducts();
  initBackToTop();
  initCountdown();
});

/* ---- Produits similaires — Shopify Recommendations API ---- */
function initRelatedProducts() {
  const wrap = document.getElementById('related-products');
  const grid = document.getElementById('related-products-grid');
  if (!wrap || !grid || !window.__currentProduct) return;

  const productId = window.__currentProduct.id;

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
    .then(r => r.json())
    .then(data => {
      let products = data.products;

      // Fallback: si l'API ne retourne rien, utiliser les produits de la même collection
      if (!products || products.length === 0) {
        const collectionHandle = window.__currentProduct?.collection;
        if (!collectionHandle) return;
        return fetch('/collections/' + collectionHandle + '/products.json?limit=7')
          .then(r => r.json())
          .then(d => {
            const filtered = (d.products || []).filter(p => p.id !== productId).slice(0, 6);
            if (filtered.length === 0) return;
            renderRelated(filtered);
          });
      }

      renderRelated(products);
    })
    .catch(() => {});

  function renderRelated(products) {
      if (!products || products.length === 0) return;
      wrap.style.display = 'block';
      grid.innerHTML = products.map(p => {
        const img = p.featured_image || (p.images && p.images[0] && p.images[0].src) || '';
        const price = (p.variants[0].price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
        const comparePrice = p.variants[0].compare_at_price;
        const priceHtml = comparePrice && comparePrice > p.variants[0].price
          ? '<span class="product-price product-price--sale">' + price + '</span><span class="product-price product-price--compare">' + (comparePrice/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'}) + '</span>'
          : '<span class="product-price">' + price + '</span>';
        return '<div class="product-card">' +
          '<a href="' + p.url + '" class="product-card__image-wrap">' +
          (img ? '<img src="' + img + '" alt="' + p.title + '" class="product-card__img product-card__img--main" loading="lazy">' : '<div class="product-card__no-image">🐱</div>') +
          '</a>' +
          '<div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<div class="product-card__price-row">' + priceHtml + '</div>' +
          '</div></div>';
      }).join('');
  }
}



/* ============================================================
   POPUP NEWSLETTER
   ============================================================ */
function initNewsletterPopup() {
  const popup = document.getElementById('nl-popup');
  if (!popup) return;

  const KEY_DONE    = 'nl_popup_done';
  const KEY_CLOSED  = 'nl_popup_closed';
  const DELAY_MS    = (parseInt(popup.dataset.delay) || 5) * 1000;
  const DAYS_WAIT   = parseInt(popup.dataset.days) || 7;

  // Ne pas afficher si déjà inscrit
  if (localStorage.getItem(KEY_DONE)) return;

  // Ne pas afficher si fermé récemment
  const closedAt = localStorage.getItem(KEY_CLOSED);
  if (closedAt) {
    const daysSince = (Date.now() - parseInt(closedAt)) / 86400000;
    if (daysSince < DAYS_WAIT) return;
  }

  function openPopup() {
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(done = false) {
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (done) {
      localStorage.setItem(KEY_DONE, '1');
    } else {
      localStorage.setItem(KEY_CLOSED, Date.now().toString());
    }
  }

  // Affichage après délai
  setTimeout(openPopup, DELAY_MS);

  // Fermeture
  document.getElementById('nl-popup-overlay')?.addEventListener('click', () => closePopup(false));
  document.getElementById('nl-popup-close')?.addEventListener('click', () => closePopup(false));
  document.getElementById('nl-popup-skip')?.addEventListener('click', () => closePopup(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.classList.contains('open')) closePopup(false); });

  // Après soumission réussie
  const form = document.getElementById('nl-popup-form');
  if (form && form.querySelector('.nl-popup__success')) {
    setTimeout(() => closePopup(true), 3000);
  }
}

document.addEventListener('DOMContentLoaded', initNewsletterPopup);

// ===== BACK TO TOP =====
function initBackToTop() {
  const btn = document.getElementById('back-to-top');
  if (!btn) return;
  const cfg = window.CATNSHOP?.backToTop || {};
  if (cfg.enabled === false) { btn.style.display = 'none'; return; }
  const offset = cfg.offset || 300;
  if (cfg.position === 'left') { btn.style.right = 'auto'; btn.style.left = '24px'; }
  const show = () => btn.classList.toggle('visible', window.scrollY > offset);
  window.addEventListener('scroll', show, { passive: true });
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}

// ===== COUNTDOWN TIMER =====
function initCountdown() {
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    const hEl = el.querySelector('[data-cd-h]');
    const mEl = el.querySelector('[data-cd-m]');
    const sEl = el.querySelector('[data-cd-s]');
    const dEl = el.querySelector('[data-cd-d]');
    if (!hEl || !mEl || !sEl) return;
    function tick() {
      const diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      hEl.textContent = String(h).padStart(2, '0');
      mEl.textContent = String(m).padStart(2, '0');
      sEl.textContent = String(s).padStart(2, '0');
      if (diff === 0) el.closest('.countdown-section')?.classList.add('countdown-ended');
    }
    tick();
    setInterval(tick, 1000);
  });
}
